module.exports = __webpack_public_path__ + "assets/img/tx101s_2.6303df0f.jpg";